var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExly = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: "24px",
    fontWeight: 600,
    transform: "translate(0 25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Exly"))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExly, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Exly.c0848919.svg";
export { ForwardRef as ReactComponent };